<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">ECU Configuration (AT+GTECU)</span>
        </div>
      </div>
    </p-header>
  
    <div class="row align-items-center">
  
      <div class="col row dvcFields">
        <div class="col lblStyle">
          <form-input fieldName="ECU Mode">
          </form-input>
        </div>
        <div class="col">
          <p-dropdown [options]="modeOptions" [(ngModel)]="ecuParameters.mode"
            [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
        </div>
      </div>
    </div>
    <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="ECU Type">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="typeOptions" [(ngModel)]="ecuParameters.type"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="ECU ON Control">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="controlOptions" [(ngModel)]="ecuParameters.controlOn"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="ECU OFF Control">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="controlOptions" [(ngModel)]="ecuParameters.controlOff"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Battery ON Control">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="batteryControlOptions" [(ngModel)]="ecuParameters.controlBatteryOn"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Relay Output Mode for Battery ON Control">
              </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <p-spinner size="5" step="1" [(ngModel)]="ecuParameters.relayOutputControlBatteryOn" [min]="0" [max]="600"></p-spinner>
                    <span class="ui-inputgroup-addon">0~600</span>
                </div>
            </div>
        </div>      
    </div>
    <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Battery OFF Control">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="batteryControlOptions" [(ngModel)]="ecuParameters.controlBatteryOff"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
              <form-input fieldName="Relay Output Mode for Battery OFF Control">
              </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <p-spinner size="5" step="1" [(ngModel)]="ecuParameters.relayOutputControlBatteryOff" [min]="0" [max]="600"></p-spinner>
                    <span class="ui-inputgroup-addon">0~600</span>
                </div>
            </div>
        </div>      
    </div>
    <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="ECU Lock">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="lockOptions" [(ngModel)]="ecuParameters.lock"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Smart Lamp">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="smartLampOptions" [(ngModel)]="ecuParameters.smartLamp"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="External battery on when SC350 battery low">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="externalBatteryOptions" [(ngModel)]="ecuParameters.externalBattery"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Delay to Check Battery Status">
            </form-input>
          </div>
          <div class="col">
            <div class="ui-inputgroup">
                <p-spinner size="5" step="1" [(ngModel)]="ecuParameters.delayBatteryStatus" [min]="10" [max]="600"></p-spinner>
                <span class="ui-inputgroup-addon">10~600</span>
                <span class="ui-inputgroup-addon">(x100ms)</span>
            </div>
        </div>
        </div>
      </div>
  </p-accordionTab>